export const QA_NAME_CALENDAR_GRID_CARD_TITLE = 'calendarGridCardTitle'
